import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Title } from "@bw/bits"
import { breakpoints } from "../../../theme"

const BlockWrapper = styled.div`
overflow: hidden;
line-height: 28px;
  padding: ${props =>
    props.type === "title"
      ? "25px 20px"
      : props.type === "conseilplus"
      ? "30px 28px"
      : "25px 25px"};
  background-color: ${props =>
    props.important ? "#EF8080" : "var(--page-color)"};
  transform: ${props => (props.type === "title" ? "translateX(-20px)" : null)};

  @media (min-width: ${breakpoints.medium}px) {
    padding: ${props =>
      props.type === "title"
        ? "45px 80px"
        : props.type === "conseilplus"
        ? "40px 50px"
        : "27px 30px"};
    max-width: ${props =>
      props.type === "title"
        ? "655px"
        : props.type === "conseilplus"
        ? "788px"
        : "461px"};
    transform: ${props => (props.type === "title" ? "translateX(0px)" : null)};
      
`

const IconWrapper = styled.div`
  min-width: 37px;
  min-height: 37px;
  margin-bottom: 15px;
`

const Block = props => (
  <BlockWrapper type={props.type} important={props.important}>
    {props.icon ? <IconWrapper>{props.icon}</IconWrapper> : null}
    <Title
      size={props.titleSize}
      suptitle={props.blockSuptitle}
      title={props.blockTitle}
      level={props.titleLevel}
    />
    {props.children}
  </BlockWrapper>
)

Block.propTypes = {
  titleSize: PropTypes.oneOf(["h2", "h4"]),
  titleLevel: PropTypes.oneOf([1, 2, 3, 4]),
  important: PropTypes.bool,
  blockSuptitle: PropTypes.string,
  blockTitle: PropTypes.string,
  icon: PropTypes.element,
  type: PropTypes.oneOf(["title", "conseilplus", "commander"]),
}

Block.defaultProps = {
  important: false,
}
export { Block }
